import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-24 md:pt-32 pb-16 md:pb-24">
        <div className="max-w-2xl mx-auto px-4 text-center">
          <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-6">
            <i className="ri-error-warning-line text-4xl"></i>
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground-900 mb-4">
            404
          </h1>
          <p className="text-lg text-foreground-600 mb-8">
            {t('notFound.message')}
          </p>
          <a href="/" className="btn-primary">
            <i className="ri-home-line mr-2"></i>
            {t('nav.home')}
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}